import { useCurrentOrg } from "@/stores/useOrgStore";
import { CANONICAL_FEATURES, type FeatureCode } from "@/features/system-admin/constants/features";

const NO_ORG_FEATURES: FeatureCode[] = [];
const DEFAULT_FEATURES = CANONICAL_FEATURES.map((feature) => feature.code);

export function useOrgFeatures(): FeatureCode[] {
  const currentOrg = useCurrentOrg();
  if (!currentOrg) return NO_ORG_FEATURES;
  return currentOrg.enabledFeatures ?? DEFAULT_FEATURES;
}
